import React, { useState } from "react";
import { useEffect } from "react";
import { chunk, random, shuffle } from "lodash";
import { TIME, resolveTime } from "./common/utils";
import Modal from "./common/Modal";
import "./Color.scss";
import { isMobile } from "../../utils/_helper";

const COLORS = [
    { text: "Green", hex: "#6AFF6F" },
    { text: "Gray", hex: "#C8C8C8" },
    { text: "Red", hex: "#FF6C36" },
    { text: "Blue", hex: "#37EBFF" },
  ],
  COLORS_COUNT = COLORS.length - 1,
  ROWS = 2,
  COLUMNS = 2,
  ROUNDS = 5,
  SECONDS = 15;
let LEVELS = Array.from({ length: ROUNDS }).map((_) => {
  let question = {
      text: COLORS[random(COLORS_COUNT)].text,
      hex: COLORS[random(COLORS_COUNT)].hex,
    },
    answer = COLORS.find((color) => color.hex === question.hex);
  return {
    question,
    answer,
    choices: shuffle(COLORS),
  };
});

const Color = ({ feature, onDone, start = null, end = null }) => {
  const [level, setLevel] = useState(0),
    [currentLevel, setCurrentLevel] = useState(LEVELS[0]),
    [modal, setModal] = useState(true),
    [modalType, setModalType] = useState("START"),
    [score, setScore] = useState(0),
    [seconds, setSeconds] = useState(SECONDS),
    [playAgain, setPlayAgain] = useState(false),
    reset = () => {
      setPlayAgain(true);
      LEVELS = Array.from({ length: ROUNDS }).map((_) => {
        let question = {
            text: COLORS[random(COLORS_COUNT)].text,
            hex: COLORS[random(COLORS_COUNT)].hex,
          },
          answer = COLORS.find((color) => color.hex === question.hex);
        return {
          question,
          answer,
          choices: shuffle(COLORS),
        };
      });
      setLevel(0);
      setCurrentLevel(LEVELS[0]);
      setScore(0);
      setSeconds(SECONDS);
    },
    nextLevel = (item) => {
      let answer = currentLevel.answer,
        statistics = { score };
      if (item.text === answer.text && item.hex === answer.hex) {
        statistics.score += 1;
        setScore(score + 1);
      }
      if (level === ROUNDS - 1) {
        setModal(true);
        setModalType("END");
        if (end) end(statistics);
      } else {
        setLevel(level + 1);
        setCurrentLevel(LEVELS[level + 1]);
      }
    };
  useEffect(() => {
    setModal(true);
    setModalType("START");
    setLevel(0);
    setCurrentLevel(LEVELS[0]);
    setScore(0);
    setSeconds(SECONDS);
    setPlayAgain(false);
  }, []);
  useEffect(() => {
    if (modalType === "") {
      let cancel = false;
      let timeout = TIME(seconds, setSeconds, cancel, true, () => {
        setModal(true);
        setModalType("END");
      });
      return () => {
        clearTimeout(timeout);
        cancel = true;
      };
    }
  }, [modalType, seconds]);
  return (
    <>
      <Modal
        feature={feature}
        show={modal}
        type={modalType}
        kind={"COLOR"}
        intro={`The game consists of reading the color and marking the color of the text.`}
        example={
          <>
            {"eg: For"}&nbsp;
            <span
              style={{
                color: "red",
                fontFamily: `"AvenirNext-Bold", sans-serif`,
              }}
            >
              Blue
            </span>
            &nbsp;
            {"answer will be"}&nbsp;
            <span
              style={{
                color: isMobile() ? "white" : "black",
                fontFamily: isMobile()
                  ? `var(--primary-heading-font)`
                  : `"AvenirNext-Bold", sans-serif`,
              }}
            >
              red
            </span>
          </>
        }
        stats={{ score: `${score}/${ROUNDS}` }}
        done={() => {
          if (modalType === "START") {
            if (start) start(playAgain ? "PLAY_AGAIN" : "START");
            setModal(false);
            setModalType("");
          } else if (modalType === "END") {
            setModal(false);
            setModalType("");
            onDone();
          }
        }}
        reset={() => {
          setModal(true);
          setModalType("START");
          reset();
        }}
      />
      <div className="game-color">
        <div className="game-color-title">Colors and Words</div>
        <div className="game-color-stats">
          <div>{`Score: ${score}`}</div>
          <div>{resolveTime(seconds)}</div>
          <div className="game-color-shuffle" onClick={() => reset()}>
            <i className="fa fa-redo" style={{ color: "#002BFF" }}></i>
          </div>
        </div>
        <div className="game-color-question">
          <div
            className="game-color-question-text"
            style={{ color: currentLevel.question.hex }}
          >
            {currentLevel.question.text}
          </div>
        </div>
        <div className="game-color-matrix">
          {chunk(currentLevel.choices, COLUMNS).map((row, rowIndex) => (
            <div key={`item${rowIndex}`} className="game-color-matrix-row">
              {row.map((column, columnIndex) => (
                <div
                  key={`item${rowIndex}${columnIndex}`}
                  className="game-color-matrix-column"
                  onClick={() => nextLevel(column)}
                >
                  <div
                    className="game-color-matrix-item"
                    style={{ backgroundColor: column.hex }}
                  >
                    {column.text}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Color;
